var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h3',[_vm._v(" User Profile ")]),_c('profile-information'),_c('two-factor-auth'),_c('reset-password'),_c('user-profile-token-index')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }